import { Stack, Typography } from '@mui/material'
import React from 'react'

import PageSection from 'components/common/PageSection'
import { ClustersListContainer } from 'components/configurations/clusters/ClustersListContainer'
import { ClustersSearch } from 'components/configurations/clusters/ClustersSearch'
import { PendingNamespaceAccessRequestAlert } from 'components/configurations/common/PendingNamespaceAccessRequestAlert'
import { useManageSharedAssets } from 'hooks/use-manage-shared-assets'
import { messageFromResponseError } from 'utils/strings'

export const ClustersPage: React.FC = () => {
  const {
    sharedAssets,
    isLoadingSharedAssets,
    isErrorSharedAssets,
    sharedAssetsError,
    hasPendingIncomingRequests
  } = useManageSharedAssets()

  return (
    <PageSection
      errorMessage={messageFromResponseError(
        sharedAssetsError,
        'We encountered an error while fetching Shared Assets. Please try again later.'
      )}
      hasError={isErrorSharedAssets}
      isLoading={isLoadingSharedAssets}
    >
      {sharedAssets && (
        // TODO: useFlexGap
        <Stack sx={{ rowGap: 4 }}>
          <Typography>
            The Gremlin Kubernetes agent will automatically detect namespaces in
            your Kubernetes cluster. You can share individual namespaces with
            other teams. By sharing individual namespaces to teams across your
            company, you can provide access for users to run experiments only on
            relevant services while also limiting access to the hosts or nodes
            themselves.
          </Typography>
          {hasPendingIncomingRequests && (
            <PendingNamespaceAccessRequestAlert title="A team is waiting for namespace sharing approval" />
          )}
          <ClustersSearch />
          <ClustersListContainer sharedAssets={sharedAssets} />
        </Stack>
      )}
    </PageSection>
  )
}
